/*
 * /TS/INTERNAL/CODE/CONFIDENTIAL
 * File: index.js
 * Project: parcel-react-tailwindcss-template
 * File Created: Saturday, 15th May 2021 9:09:15 pm
 * Author: Mark Kennard (mark.kennard@threatstatus.com)
 * -----
 * Last Modified: Saturday, 15th May 2021 9:09:15 pm
 * Modified By: Mark Kennard (mark.kennard@threatstatus.com>)
 * -----
 * Copyright 2018 - 2021 Threat Status Limited
 */
import React from 'react'

export default function Footer(props) {
  return (
    <div className="w-full mt-4 ">
      <div className="mt-0  p-4 text-center text-snowmeister-600 text-shadow-white text-xs">&copy; 2021 - Claire Quinn - All rights reserved</div>
    </div>
  )
}
